import type { ReactNode } from 'react';

export const symbol_pentagon: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M283.6-180H676l133-397-329-229-329 229 132.6 397Zm-.6 60q-19.5 0-35.25-11.18T226-161L94-558q-6-19 .11-37.85 6.1-18.84 22.89-30.15l329-230q16-11 34-11t34 11l329 230q16.79 11.31 22.89 30.15Q872-577 866-558L734-161q-6 18.64-21.75 29.82T677-120H283Zm197-373Z"
		/>
	</svg>
);
